import { render } from "./CollectionHub.vue?vue&type=template&id=07c54dae&scoped=true"
import script from "./CollectionHub.vue?vue&type=script&lang=js"
export * from "./CollectionHub.vue?vue&type=script&lang=js"

import "./CollectionHub.vue?vue&type=style&index=0&id=07c54dae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07c54dae"]])

export default __exports__